export const subscriptionStatus = {
  active: 'Active',
  paused: 'Paused',
  canceled: 'Canceled',
  complete: 'Complete',
  payment_failed: 'Payment Failed',
  deleted_customer: 'Deleted Customer',
};
